import styled from 'styled-components';

export const MultilineText = styled.p`
  white-space: pre-line;
`;
